import apiWebReferral from '@/api/webReferral';

const defaultState = () => ({
	webReferralThemeResults: [],
	webReferralThemePagination: '',
	responSukses: '',
	konfirmResponse: {},
	alert: '',
	productToSellResults: [],
	response: {
		code: '',
		message: ''
	},
	alertMultiple: [],
	responseError: {},
});

const state = defaultState();

const getters = {

};

const mutations = {
	listWebReferralTheme(state, data) {
		state.webReferralThemeResults = data.data
		state.webReferralThemePagination = data.pagination;
	},
	konfirmasiSukses(state, data) {
		state.responSukses = data;
		state.konfirmResponse = {};
	},
	saveConfirmResponse(state, data) {
		state.konfirmResponse = data;
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataTheme(state){
		Object.assign(state, defaultState())
	},
	listOptionProductToSell(state, data) {
		state.productToSellResults = data.data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
};

const actions = {
	getDataTheme({ commit }, params) {
		apiWebReferral.getDataTheme(params).then(({ data: { data } }) => {
			commit('listWebReferralTheme', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listWebReferralTheme', { data: [], pagination: {} } );
		});
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	getProductToSell({ commit }, params) {
		apiWebReferral.getProductToSell(params).then(({ data: { data } }) => {
			commit('listOptionProductToSell', { data: data.results, pagination: data.pagination } );
		}).catch(() => {
			commit('listOptionProductToSell', { data: [], pagination: {} } );
		});
	},
	async createTheme({ commit, dispatch }, params) {
		await apiWebReferral.createTheme(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data

			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal membuat theme'
			}, { root: true });
		});
	},
	async deleteTheme({ commit, dispatch }, params) {
		await apiWebReferral.deleteTheme(params).then(res => {
			const data = res.data;
			commit("saveResponse", data);
			dispatch('success', data)
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus theme'
			}, { root: true });
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};